import { Tooltip } from '@app/components';
import InfoIcon from '@app/assets/icons/info.svg?react';

interface BusinessContactsProps {
  email?: string;
  phoneNumber?: string;
}

export const BusinessContacts = ({ email, phoneNumber }: BusinessContactsProps) => {
  const displayEmail = email || '—';
  const displayPhone = phoneNumber || '—';

  return (
    <div className="bg-white rounded-xl border border-base-ghostWhite w-full self-start h-fit">
      <div className="p-4 border-b border-b-base-ghostWhite">
        <h5 className="font-bold mb-1">Business contacts</h5>

      </div>
      <div className="p-4 space-y-4">
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <p className="font-semibold">Business email</p>
            <Tooltip content={<span className="text-xs">Business contact</span>}>
              <span aria-label="More info" className="inline-flex items-center justify-center">
                <InfoIcon width={22} height={22} />
              </span>
            </Tooltip>
          </div>
          <div className="rounded-xl bg-base-antiFlash px-4 py-2 flex items-center justify-between">
            <span className="text-base-raisinBlack break-all">{displayEmail}</span>
            <span className="text-system-success text-lg" aria-hidden>
              ✓
            </span>
          </div>
        </div>
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <p className="font-semibold">Business phone</p>
            <Tooltip content={<span className="text-xs">Business contact</span>}>
              <span aria-label="More info" className="inline-flex items-center justify-center">
                <InfoIcon width={22} height={22} />
              </span>
            </Tooltip>
          </div>
          <div className="rounded-xl bg-base-antiFlash px-4 py-2 flex items-center justify-between">
            <span className="text-base-raisinBlack break-all">{displayPhone}</span>
            {phoneNumber && (
              <span className="text-system-success text-lg" aria-hidden>
                ✓
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessContacts;


